import { Redirect } from 'react-router-dom';
import { LEARNING_PATH, FREE_LEARNING_PATH } from '../util/consts';
import React from 'react';

const dlConfig = {
    settings: {
        customScrollbars: false,
        layout: {
            style: 'layout1',
            config: {
                needUserInfo: true,
                redirectOn401: true,
                hasPreview: true,
                navbar: {
                    folded: true
                },
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: LEARNING_PATH + '/:serviceName/my-jobs',
            component: React.lazy(() => import('./dls'))
        },
        {
            path: LEARNING_PATH + '/:serviceName/job/:dlId?',
            component: React.lazy(() => import('./dl'))
        },
        
        {
            path: FREE_LEARNING_PATH + '/:serviceName/job/:dlId?',
            component: ({ match }) => <Redirect to={`${LEARNING_PATH}/${match.params.serviceName}/job/${match.params.dlId ? match.params.dlId : ''}`} />

        },
    ]
};


export { dlConfig };
